import { Stack, IconButton, Box } from "@mui/material";
import useWavesurfer from "./useWaveSurfer";
import PauseOutlinedIcon from "@mui/icons-material/PauseOutlined";
import SkipPreviousRoundedIcon from "@mui/icons-material/SkipPreviousRounded";
import SkipNextRoundedIcon from "@mui/icons-material/SkipNextRounded";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import React, { useEffect, useState, useRef, useCallback } from "react";
import { Images } from "../../assets/common";
import "./index.scss"

export default function WaveSurferPlayer({
  url,
  handleNext,
  handlePrev,
  handlePlay,
  handleCurrentTime,
  handleEnd,
  handleSeek,
  handleDuration,
  sampleData,
  volume,
  showAdv,
}) {
  const containerRef = useRef();
  const [isPlaying, setIsPlaying] = useState(false);
  const wavesurfer = useWavesurfer(containerRef, url, sampleData);
  const [isHoverRight, setIsHoverRight] = useState(false);
  const [isHoverLeft, setIsHoverLeft] = useState(false);

  const onPlayClick = useCallback(() => {
    wavesurfer.isPlaying() ? wavesurfer.pause() : wavesurfer.play();
  }, [wavesurfer]);

  useEffect(() => {
    if (!wavesurfer) return;
    wavesurfer.setVolume(volume / 100);
  }, [volume]);
  
  useEffect(() => {
    if (!wavesurfer) return;
    onPlayClick();
  }, [showAdv]);

  // Listen for global stop event
  useEffect(() => {
    const handleStopAllPlayers = (event) => {
      console.log('[WaveSurferPlayer] Received stop-all-players event');
      if (wavesurfer && wavesurfer.isPlaying()) {
        wavesurfer.pause();
      }
    };
    
    window.addEventListener('stop-all-players', handleStopAllPlayers);
    
    return () => {
      window.removeEventListener('stop-all-players', handleStopAllPlayers);
    };
  }, [wavesurfer]);

  useEffect(() => {
    if (!wavesurfer) return;

    const subscriptions = [
      wavesurfer.on("ready", () => {
        wavesurfer.setVolume(volume / 100);
        wavesurfer.play();
        const duration = wavesurfer.getDuration();
        console.log(`🎵 WAVESURFER READY: duration=${duration}`);
        if (handleDuration) handleDuration(duration);
        handleCurrentTime(0);
        handlePlay(true);
      }),
      wavesurfer.on("play", () => {
        setIsPlaying(true);
        handlePlay(true);
      }),
      wavesurfer.on("pause", () => {
        setIsPlaying(false);
        handlePlay(false);
      }),
      wavesurfer.on("timeupdate", (currentTime) => {
        handleCurrentTime(currentTime);
      }),
      wavesurfer.on("interaction", (currentTime) => {
        handleSeek(currentTime);
      }),
      wavesurfer.on("finish", () => {
        handleEnd();
      }),
    ];

    return () => {
      subscriptions.forEach((unsub) => unsub());
    };
  }, [wavesurfer, url]);

  return (
    <>
      <Stack
        className="surfer_bar"
        sx={{ width: "100%", justifyContent: "space-around", alignItems: "center" }}
        direction="row"
        spacing={4}
      >
        <Stack
          sx={{ justifyContent: "center", alignItems: "center" }}
          direction="row"
          spacing={2}
        >
          <Box
            aria-label="prev song"
            onClick={handlePrev}
            className="_cp"
            onMouseEnter={() => {
              setIsHoverLeft(true);
            }}
            onMouseLeave={() => {
              setIsHoverLeft(false);
            }}
          >
            <img
              src={isHoverLeft ? Images.prev_icon_hover : Images.prev_icon}
            />
          </Box>

          <IconButton
            aria-label="play song"
            sx={{ backgroundColor: "#2E2E2D" }}
            onClick={onPlayClick}
          >
            {!isPlaying ? (
              <PlayArrowRoundedIcon
                sx={{ fontSize: "30px" }}
                color="default"
                className="_cp"
              />
            ) : (
              <PauseOutlinedIcon
                sx={{ fontSize: "30px" }}
                color="default"
                className="_cp"
              />
            )}
          </IconButton>

          <Box
            aria-label="next song"
            onClick={handleNext}
            className="_cp"
            onMouseEnter={() => {
              setIsHoverRight(true);
            }}
            onMouseLeave={() => {
              setIsHoverRight(false);
            }}
          >
            {/* <SkipNextRoundedIcon
              className="_cp"
              sx={{ fontSize: "30px" }}
              color="default"
            /> */}
            <img
              src={isHoverRight ? Images.next_icon_hover : Images.next_icon}
            />
          </Box>
        </Stack>
        <div ref={containerRef} style={{ width: "50%", cursor: "pointer" }} />
      </Stack>
    </>
  );
}
